import React from 'react';
import { Badge } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

function formatClubWithCompetitorNo(competitorNo, clubName) {
    const club = String(clubName || '').trim();
    const number = String(competitorNo || '').trim();
    if (!number) return club;
    if (!club) return number;
    if (/^(TBC|BYE)$/i.test(club)) return club;
    if (club.startsWith(`${number} - `)) return club;
    return `${number} - ${club}`;
}

function formatEventTitle(value) {
    const titleCased = String(value || '')
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    return titleCased
        .replace(/\bmas\s*([a-j](?:\s*\/\s*[a-j])*)\b/gi, (_, category) => `Mas${String(category).replace(/\s+/g, '').toUpperCase()}`)
        .replace(/\bmas([a-j](?:\/[a-j])*)\b/gi, (_, category) => `Mas${String(category).toUpperCase()}`)
        .replace(/\b(i|ii|iii|iv|v|vi|vii|viii|ix|x|xi|xii)\b/gi, token => token.toUpperCase());
}

export function RaceTimetableLine({ value, showMastersCategory, changeA, changeB, changeC, changeD, changeE, changeZ, showCanvas, showDrawCanvas, showStart, showStop, showResult, showMove, hasSpareRaces }) {
    const handleAlignClick = () => changeZ(value.raceId);
    const handleStartClick = () => changeA(value.raceId);
    const handleAbortClick = () => changeB(value.raceId);
    const handleResultClick = () => changeC(value.raceId);
    const handleMoveRaceClick = () => changeD(value.raceId);
    const handleChangeTimeClick = () => changeE(value.raceId);
    const handleCanvasOpen = () => showCanvas(value.raceId);
    const handleDrawCanvasOpen = () => showDrawCanvas(value.raceId);
    const isHandicapEvent = Boolean(value?.event?.handicapEvent);
    const laneAMastersCategory = String(value?.laneA?.mastersCategory || '').trim().toUpperCase();
    const laneBMastersCategory = String(value?.laneB?.mastersCategory || '').trim().toUpperCase();

    const laneAMeta = (
        <>
            <span className='crew-name'>{value.laneA.suffix}</span>
            {showMastersCategory && isHandicapEvent && laneAMastersCategory && <span className='masters-category-tag'>[{`Mas${laneAMastersCategory}`}]</span>}
        </>
    );
    const laneBMeta = (
        <>
            <span className='crew-name'>{value.laneB.suffix}</span>
            {showMastersCategory && isHandicapEvent && laneBMastersCategory && <span className='masters-category-tag'>[{`Mas${laneBMastersCategory}`}]</span>}
        </>
    );

    const laneATitle = value?.laneA?.title || '';
    const laneBTitle = value?.laneB?.title || '';
    const eventTitle = formatEventTitle(value?.event?.title || '');
    const laneACompetitorNo = value?.laneA?.competitorNo || '';
    const laneBCompetitorNo = value?.laneB?.competitorNo || '';
    const laneATitleAbbreviated = value?.laneA?.titleAbbreviated || value?.laneA?.titleMobile || laneATitle;
    const laneBTitleAbbreviated = value?.laneB?.titleAbbreviated || value?.laneB?.titleMobile || laneBTitle;
    const laneAFullDisplay = formatClubWithCompetitorNo(laneACompetitorNo, laneATitle);
    const laneBFullDisplay = formatClubWithCompetitorNo(laneBCompetitorNo, laneBTitle);
    const laneAAbbrevDisplay = formatClubWithCompetitorNo(laneACompetitorNo, laneATitleAbbreviated);
    const laneBAbbrevDisplay = formatClubWithCompetitorNo(laneBCompetitorNo, laneBTitleAbbreviated);
    const winnerSummary = [value?.verdict, value?.winningTime]
        .map(part => String(part || '').trim())
        .filter(Boolean)
        .join(' ');

    const laneAClubDisplay = (
        <>
            <span className='tt-club-name-full'>{laneAFullDisplay}</span>
            <span className='tt-club-name-abbrev'>{laneAAbbrevDisplay}</span>
        </>
    );
    const laneBClubDisplay = (
        <>
            <span className='tt-club-name-full'>{laneBFullDisplay}</span>
            <span className='tt-club-name-abbrev'>{laneBAbbrevDisplay}</span>
        </>
    );

    const winnerContent = (laneClubDisplay, laneMeta) => (
        <>
            <span className="tt-winner-main">{laneClubDisplay}</span>
            <span className="tt-winner-meta">{laneMeta}</span>
            {winnerSummary && <span className="winner-result-badge">{winnerSummary}</span>}
        </>
    );

    let laneA = <div className='col-6 club-name'>{laneAClubDisplay} {laneAMeta}</div>;
    let laneB = <div className='col-6 club-name'>{laneBClubDisplay} {laneBMeta}</div>;

    if (value.laneA.winner) {
        laneA = <div className='col-6 club-name'><button type="button" className="winner">{winnerContent(laneAClubDisplay, laneAMeta)}</button></div>;
        laneB = <div className='col-6 club-name loser'>{laneBClubDisplay} {laneBMeta}</div>;
    }
    else if (value.laneB.winner) {
        laneA = <div className='col-6 club-name loser'>{laneAClubDisplay} {laneAMeta}</div>;
        laneB = <div className='col-6 club-name'><button type="button" className="winner">{winnerContent(laneBClubDisplay, laneBMeta)}</button></div>;
    }

    let raceTimeArea = value.raceTimeFormatted;
    if (value.status===1) {
        raceTimeArea = <Badge bg="warning">Next Up</Badge>
    }
    if (value.status === 2) {
        raceTimeArea = <Badge bg="dark">Racing</Badge>
    }
    let adjuster = 0;
    if (!showStart && !showStop && !showResult && !showMove)
        adjuster = 1;

    return (
        <div className='row rowStyle timetableRace'>
            <Col md={5}>
                <Row>
                    <div className='col-1 order-first mobile-smaller'>{value.raceNo}</div>
                    <div className='col-1 order-first d-none d-lg-inline'>{value.nextRaceNo}</div>
                    <div className='col-8 col-lg-7 event-title mobile-smaller text-truncate' onClick={handleDrawCanvasOpen} style={{ cursor: "help" }}>{eventTitle}
                        {(showMove || showStart) && value.handicapTime > 0 && 
                            <><br />
                            <span className='crew-name text-capitalize fst-italic'>Handicap {value.handicapTime}s</span></>
                            }
                    </div>
                    <div className='col-1 mobile-smaller text-nowrap'>{value.round}</div>
                    <div className='col-2 order-md-first order-sm-last mobile-smaller text-end text-md-start'>{raceTimeArea}</div>
                </Row>
                </Col>
            <Col md={adjuster ? 7 : 5}>
                <Row onClick={handleCanvasOpen} style={{ cursor: "help" }}>
                    {laneA}
                    {laneB}
                </Row>
            </Col>
            <div className='col-md-2 d-none d-md-block actionsCell pt-2 d-print-none ipadMiniAdjust'>
                {showMove && value.event.id > -1 &&
                    <DropdownButton id="dropdown-basic-button" title="Actions" align="end">
                        {hasSpareRaces && <Dropdown.Item as="button" onClick={handleMoveRaceClick} disabled={value.status !== 0 && value.verdict !== 'scr'}>Move Race</Dropdown.Item>}
                        <Dropdown.Item as="button" onClick={handleChangeTimeClick} disabled={value.status !== 0 && value.verdict !== 'scr'}>Change Race Time</Dropdown.Item>
                        <Dropdown.Item as="button" onClick={handleAbortClick} disabled={value.status !== 3}>Cancel Timing</Dropdown.Item>
                        <Dropdown.Item as="button" onClick={handleResultClick}>Submit Result</Dropdown.Item>
                    </DropdownButton>
                }
                {!showMove && showStart && value.status === 0 && value.event.id > -1 &&
                    <button className="btn btn-outline-primary ipadMiniAdjust" onClick={handleAlignClick}>Aligning</button>
                }
                {!showMove && showStop && value.status === 1 && value.event.id > -1 &&
                    <button className="btn btn-outline-primary" onClick={handleStartClick}>GO!</button>
                }
                {!showMove && showStop && value.status === 2 && value.event.id > -1 &&
                    <button className="btn btn-outline-primary" onClick={handleAbortClick}>Cancel Timing</button>
                }
                {!showMove && showResult && value.event.id > -1 &&
                    <button className="btn btn-outline-primary text-nowrap" onClick={handleResultClick}>Submit Result</button>
                }
        </div></div>
    )
}